<template>
    <report-table></report-table>
</template>

<script>
    const reportTable =() => import ('@/components/orgApps/Report/ReportTable');

    export default {
        name: "reportDash",
        components: {
            reportTable,
        }
    }
</script>

<style scoped>

</style>